import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { useHomeContextUser } from "../../homeContext.ts";

export default function useSupportsRecommendations() {
  const brand = useBrandLoaderData();
  const user = useHomeContextUser();

  return (
    brand.Recommendations.enabled &&
    user.instructor.hasRole &&
    user.instructor.verified
  );
}
